import React, { useState, useEffect, useContext } from 'react';
import SiteSelectorModal from 'components/shared/siteSelector/siteSelectorModal';
import AuthContext from 'contexts/authContext';
import Helpers from 'utils/helpers';
import './siteContext.css';

import image_storelocation from 'assets/images/storelocation.png';

function SiteContext(props) {
  const { authState } = useContext(AuthContext);

  const hierarchyId = props.hierarchyId;
  const isShowPath = !props.hidePath;
  const [isReadOnly, setIsReadOnly] = useState(props.readOnly);
  const [showPopup, setShowPopup] = useState(false);
  const [selection, setSelection] = useState({ id: null, name: 'No Selection', type: '', parents: [] });

  useEffect(() => {
    const sitesList = authState.hierarchy;
    const nodeCount = sitesList.filter((site) => site.typeId === 5).length;
    if (nodeCount <= 1) {
      setIsReadOnly(true);
    }
  }, []);

  useEffect(() => {
    if (hierarchyId != null) {
      const sitesList = authState.hierarchy;
      const node = sitesList.filter((site) => site.id === hierarchyId)[0];
      const selectionTmp = {
        id: node.id,
        name: node.name,
        type: node.typeId === 5 ? 'Store' : '',
        parents: []
      };
      let parents = sitesList.filter((site) => site.id === node.parentId);
      let parent = null;
      var getParent = (site) => site.id === parent.parentId;
      while (parents.length > 0) {
        parent = parents[0];
        selectionTmp.parents.unshift(parent.name);
        parents = sitesList.filter(getParent);
      }
      setSelection(selectionTmp);
    }
  }, [hierarchyId]);

  const handleSelectSites = (ids) => {
    if (props.onSelectSite) {
      props.onSelectSite(ids[0]);
    }
  };

  return (
    <>
      <div className='site-context'>
        <div className={'site-context-content ' + (!isReadOnly ? ' editable' : '')} onClick={() => setShowPopup(!isReadOnly)}>
          <div className='d-flex justify-content-between align-items-center'>
            <div>
              <div className='site-context-name'>{selection.name}</div>
              <div className='site-context-type'>{selection.type}</div>
            </div>
            <div className='site-context-button'>{!isReadOnly ? <i className='icons8-edit' /> : null}</div>
          </div>
          {!isShowPath ? null : (
            <div className='site-context-path'>
              {(selection.parents || []).map((item, index) => (
                <span key={index}>
                  {index > 0 ? <span className='seperator'>/</span> : null}
                  <span className='no-break'>{item}</span>
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      <SiteSelectorModal
        show={showPopup}
        onClose={() => setShowPopup(false)}
        onChange={handleSelectSites}
        sitesSelected={selection.id ? [selection.id] : []}
        isSingleSelect={true}
        selectableFn={(node) => node.typeId === 5}
      />
    </>
  );
}

function SiteContextButton(props) {
  const { authState } = useContext(AuthContext);

  const [isReadOnly, setIsReadOnly] = useState(props.readOnly);
  const [showPopup, setShowPopup] = useState(false);
  const [selection, setSelection] = useState({ id: null, name: 'No Selection', typeName: '' });
  const [isLoaded, setIsLoaded] = useState(false);

  const hierarchyId = props.hierarchyId;
  const isParentLoaded = (props.loaded === undefined ? true : props.loaded);
  const selectableFn = props.selectableFn || ((node) => node.typeId === 5);

  useEffect(() => {
    if (!isReadOnly && !props.readOnly) {
      if (hierarchyId) {
        //make control read only if only one selection is available
        const sitesList = authState.hierarchy;
        const nodeCount = sitesList.filter(selectableFn).length;
        if (nodeCount <= 1) {
          setIsReadOnly(true);
        }
      }
    }
  }, [hierarchyId, selectableFn, isReadOnly, props.readOnly]);

  useEffect(() => {
    if (hierarchyId) {
      const sitesList = authState.hierarchy;
      const site = sitesList.filter((node) => node.id === hierarchyId)[0];
      if (site) {
        const selectionTmp = {
          id: site.id,
          name: site.name,
          typeName: site.typeId === 5 ? 'Store' : '',
        };
        setSelection(selectionTmp);
      }
    }
    setIsLoaded(true);
  }, [hierarchyId]);

  const handleSelectSites = (ids) => {
    if (props.onSelectSite) {
      props.onSelectSite(ids[0]);
    }
  };

  const getClass = () => {
    let classNames = ['site-context-header'];
    if (!isReadOnly && !props.readOnly) {
      classNames.push('editable');
    }
    if (selection.id <= 0) {
      classNames.push('error');
    }
    return Helpers.String.join(classNames);
  };

  if (!isLoaded || !isParentLoaded) {
    return null;
  }

  return (
    <>
      <div className={getClass()} onClick={() => setShowPopup(!isReadOnly)}>
        <img src={image_storelocation} alt='Store Selection' />
        {/*<div className='site-context-header-title'>{(isReadOnly ? 'Store' : 'Select Store')}</div>*/}
        <div>
          <div className='site-context-header-button'>
            {selection.name}
            <i className='icons8-chevron-down' />
          </div>
        </div>
      </div>
      {isReadOnly ? null : (
        <SiteSelectorModal
          show={showPopup}
          onClose={() => setShowPopup(false)}
          onChange={handleSelectSites}
          sitesSelected={selection.id ? [selection.id] : []}
          isSingleSelect={true}
          selectableFn={selectableFn}
        />
      )}
    </>
  );
}

SiteContext.Button = SiteContextButton;

export default SiteContext;